import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NavLink } from 'react-router-dom';
import './AdministratorSidebar.css';
import "bootstrap/dist/css/bootstrap.min.css"; // Add Bootstrap for styling

const AdministratorSidebar = () => {
  const [isSidebarActive, setIsSidebarActive] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null); // Track which submenu is open

  const toggleSidebar = () => {
    setIsSidebarActive(!isSidebarActive);
  };

  // Toggle function for home and pages submenu, with close for the other submenu
  const toggleSubmenu = (submenu) => {
    setOpenSubmenu(openSubmenu === submenu ? null : submenu); // Close if the same submenu is clicked
  };

  return (
    <div className="wrapper">
      {/* Sidebar Holder */}
      <nav id="sidebar" className={isSidebarActive ? 'active' : ''}>
        <div className="sidebar-header">
          <h3>Administrator Panel</h3>
        </div>

        <ul className="list-unstyled components">
          {/* Display user's first and last name */}

          <li>
            <Link to="/admin-panel">Dashboard</Link>
          </li>

          <li>
            <Link to="/panel-auction">Auction</Link>
          </li>

          <li className={openSubmenu === 'home' ? 'active' : ''}>
            <a
              href="#homeSubmenu"
              onClick={() => toggleSubmenu('home')} // Pass submenu identifier
              className="dropdown-toggle"
            >
              Vehicles Details
            </a>
            {openSubmenu === 'home' && (
              <ul className="list-unstyled">
                <li>
                  <Link to="/vehicles">View Vehicle List</Link>
                </li>
                <li>
                  <Link to="/add-vehicle">Add New Vehicle</Link>
                </li>
                <li>
                  <Link to="/vehicles-cost">Vehicle Cost</Link>
                </li>
              </ul>
            )}
          </li>

          <li className={openSubmenu === 'sales' ? 'active' : ''}>
            <a
              href="#saleSubmenu"
              onClick={() => toggleSubmenu('sales')} // Pass submenu identifier
              className="dropdown-toggle"
            >
              Sales Details
            </a>
            {openSubmenu === 'sales' && (
              <ul className="list-unstyled">
                <li>
                  <Link to="/view-sales">View All Sales</Link>
                </li>
                <li>
                  <Link to="/add-new-sale">Create New Sale</Link>
                </li>
              </ul>
            )}
          </li>

          <li className={openSubmenu === 'docs' ? 'active' : ''}>
            <a
              href="#saleSubmenu"
              onClick={() => toggleSubmenu('docs')} // Pass submenu identifier
              className="dropdown-toggle"
            >
              Documents & Shipping
            </a>
            {openSubmenu === 'docs' && (
              <ul className="list-unstyled">
                <li>
                  <Link to="/documents-shipping">Documents/Shipping</Link>
                </li>
              </ul>
            )}
          </li>

          <li className={openSubmenu === 'pay' ? 'active' : ''}>
            <a
              href="#saleSubmenu"
              onClick={() => toggleSubmenu('pay')} // Pass submenu identifier
              className="dropdown-toggle"
            >
              Payments
            </a>
            {openSubmenu === 'pay' && (
              <ul className="list-unstyled">
{/*                 
                <li>
                  <Link to="/payments">View Allocate</Link>
                </li>
*/}                
                <li>
                  <Link to="/volet">View Wallet</Link>
                </li>
                <li>
                  <Link to="/create-volet">Receive Wallet Amount</Link>
                </li>
                <li>
                  <Link to="/view-payments">View Allocated Payments</Link>
                </li>
                <li>
                  <Link to="/create-allocate">Add Allocated Amount</Link>
                </li>
                <li>
                  <Link to="/refund-amount">Refund Amount</Link>
                </li>
              </ul>
            )}
          </li>

          <li>
            <Link to="/accounts">Accounts</Link>
          </li>

          <li>
            <Link to="/calculator-edit">Calculator</Link>
          </li>

          <li>
            <Link to="/portfolio">Portfolio</Link>
          </li>          

          <li className={openSubmenu === 'pages' ? 'active' : ''}>
            <a
              href="#pageSubmenu"
              onClick={() => toggleSubmenu('pages')} // Pass submenu identifier
              className="dropdown-toggle"
            >
              Settings
            </a>
            {openSubmenu === 'pages' && (
              <ul className="list-unstyled">
                <li>
                  <NavLink to="/view-user">All Users</NavLink>
                </li>
                <li>
                  <NavLink to="/create-account">Create Account</NavLink>
                </li>
              </ul>
            )}
          </li>
          
        </ul>
      </nav>
      {/* Page Content Holder */}
    </div>
  );
};

export default AdministratorSidebar;
